import {useState, useEffect} from 'react';
import Search from '../icons/Search';
import {useSearchBox, type UseSearchBoxProps} from 'react-instantsearch';

export default function CustomSearchBox(props: UseSearchBoxProps) {
  const {query, refine} = useSearchBox(props);
  const [inputValue, setInputValue] = useState(query);

  useEffect(() => {
    setInputValue(query);
  }, [query]);

  function setQuery(newQuery: string) {
    setInputValue(newQuery);
    refine(newQuery);
  }
  return (
    <div className="relative flex w-full items-center justify-between overflow-hidden rounded-full bg-light-beige px-7 py-3">
      <input
        type="text"
        className="richH7 focus:shadow-none w-full border-0 bg-light-beige p-0 leading-[1] text-orange placeholder:text-orange focus:outline-none focus:ring-0"
        placeholder="Search for a retailer"
        value={inputValue}
        onChange={(event) => {
          setQuery(event.currentTarget.value);
        }}
      />
      <Search />
    </div>
  );
}
